import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  Table,

} from "reactstrap"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "components/ButtonSpinner"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import Modal from "react-bootstrap/Modal"
//components
import Breadcrumbs from "components/Common/Breadcrumb"
import * as clientCompleteAction from "store/ZXZlbnRDbGllbn/actions"
import api from "helpers/Api"
import { ToastContainer, toast } from "react-toastify"
//clientCompleteAction
const EventClientComplete = (props) => {
  const title = "Event Client Complete"
  const { dispatch, searchBtnStyle } = props
  // edit column modal
  const [columnModal, setColumnModal] = useState(false)
  //empid
  const empId = localStorage.getItem("empId")

  useEffect(() => {
    dispatch(clientCompleteAction.loadRecordsMetaData())
    dispatch(
      clientCompleteAction.loadClientComplete({
        page: 1,
        limit: 50,
       // empId: empId,
        isOperationStatus: true,
      })
    )
  }, [])
  const specificDispatch = useDispatch()

  const update = useSelector((state) => state.eventClientComplete)

  const {
    recordsMetaData = {},
    clientComplete_details = [],
    crmError,
    crmSuccess,
  } = update

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //crm manage client filter initial state
  const [eventClientCompleteData, setEventClientCompleteData] = useState({
    leadNo: "",
    fromDate: "",
    toDate: "",
  })
  const fuseAgentOptions = {
    keys: ["empCode", "label"],
  }
  //handle change
  const handleChange = async (e) => {
    setEventClientCompleteData({
      ...eventClientCompleteData,
      [e.target.name]: e.target.value,
    })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
 
  const [agent, setAgent] = useState([])
  const [agentKey, setAgentKey] = useState(false)
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setSearchInput("")
    setAgentKey(true)
    setAgent([])
    setTimeout(()=>{
      setAgentKey(false)
    },0)
    setEventClientCompleteData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    setSearchValueList({
      page: 1,
      limit: 50,
    //  empId: empId,
      isOperationStatus: true,
    })
    dispatch(
      clientCompleteAction.loadClientComplete({
        page: 1,
        limit: 50,
      //  empId: empId,
        isOperationStatus: true,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)

  //dropdown options

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,
        //  empId: empId,
          isOperationStatus: true,
        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          //empId: empId,
          isOperationStatus: true,
          searchFilter: searchInput,
        }
  //apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? companies.value : ""
    var searchBranch = branches && branches ? branches.value : ""
    var searchEvent = events && events ? events.value : ""
    var searchLeadNo = eventClientCompleteData.leadNo
      ? eventClientCompleteData.leadNo
      : ""
    var searchFromDate =
      eventClientCompleteData && eventClientCompleteData.fromDate
        ? moment(eventClientCompleteData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      eventClientCompleteData && eventClientCompleteData.toDate
        ? moment(eventClientCompleteData.toDate).format("YYYY-MM-DD")
        : ""
  var searchEmp = agent&&agent.value
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
   // searchvalue.empId = empId
    searchvalue.isOperationStatus = true
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if(searchEmp){
      searchvalue.empId = searchEmp
    }
    setSearchValueList(searchvalue)
    specificDispatch(clientCompleteAction.loadClientComplete(searchvalue))
 
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }
  //Reactive
  const [reactiveModal,setReactiveModal] = useState(false)
  const [reactiveData,setReactiveData] = useState({
    remarks:""
  })
  const handleReactiveChange = (e) =>{
    setReactiveData({...reactiveData,[e.target.name]:e.target.value})
  }
  //assigned history modal
  const [historyModal, setHistoryModal] = useState(false)
  const [leadId, setLeadId] = useState("")
  const [clearanceHistoryModal, setClearanceHistoryModal] = useState(false)
  const [clearanceHistoryDetails, setClearanceHistoryDetails] = useState("")
  const [clearanceModal, setClearanceModal] = useState(false)
  const [clearanceDetails, setClearanceDetails] = useState("")
  const [deliverablesModal, setDeliverablesModal] = useState(false)
  const [deliverablesData, setDeliverablesData] = useState([])
  let slNo = 0
  const [clientCompleteModal, setClientCompleteModal] = useState(false)
  const clientCompleteDataTable = !isEmpty(clientComplete_details)
    ? clientComplete_details.data.map((data, index) => {
      slNo = slNo + 1
      const deliverableCount =
        !isEmpty(data) && data.deliverableDetails.length > 0
          ? data.deliverableDetails.length
          : 0

      const paymentStatus = !isEmpty(data.leadClearance)
        ? data.leadClearance.type
        : ""

      return {
        rowData: data,
        _id: data.leadId,
        sNo: slNo,
        leadNo: data.leadNo,
        branchId: data.branchId,
        branchName: data.branchName ? data.branchName : "--",
        clientName: data.clientName ? data.clientName : "--",
        clientCode: data.clientCode ? data.clientCode : "--",
        companyId: data.companyId,
        crmAssign: data.postCrmAssignedName ? data.postCrmAssignedName : "--",
        companyName: data.companyName ? data.companyName : "--",
        deliverables: deliverableCount,
        leadDate: data.leadDate
          ? moment(data.leadDate).format(dateFormat)
          : "",
        overallStatus: data.overallStatus,
        deliverableDetails: data.deliverableDetails,
        assignedEmployee: data.assignedEmployee,
        assignedTeamlead: data.assignedTeamlead,
        key: index,
        link: data.link ? data.link : "--",
        assignedHistory: data.assignedHistory,
        clearanceStatusName: data.ecClearanceStatusName,
        paymentStatus: paymentStatus,
        groomName: data.groomName ? data.groomName : "--",
        brideName: data.brideName ? data.brideName : "--",
        clearanceDetails: data,
        ecClearanceStatus: data.ecClearanceStatus,
        assignedDate:
          !isEmpty(data.postCrmAssignedDate) ||
            data.postCrmAssignedDate != null
            ? moment(data.postCrmAssignedDate).format(dateFormat)
            : "--",
        clearanceHistory: data.leadClearanceHistory
          ? data.leadClearanceHistory
          : "",
        cpStatus:
          data.clientProfileStatus && data.clientProfileStatus != null
            ? data.clientProfileStatus
            : "--",
        cpRemarks: data.clientProfileRemarks
          ? data.clientProfileRemarks
          : "--",
          completedByName:data.clientCompletedByName?data.clientCompletedByName:"--",
          completedByDate:data.clientCompletedDate?moment(data.clientCompletedDate).format(dateFormat):"--"
      }
    })
    : []
  const [clientLeadId,setClientLeadId] = useState("")
  //assign history api call
  const assignHistory = (data) => {
    const historyPayload = {
      operationId: data.operationId,
      deliverableId: data.leadDelivarableId,
      mode: "POST",
    }
    setHistoryModal(true)
    setTimeout(() => {
      dispatch(clientCompleteAction.loadProductionAssignHistory(historyPayload))
    }, 1000)
  }
  const historyUpdate = useSelector((state) => state.crmMyClient)

  const { history_details = [] } = historyUpdate

  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      formatter: (cellContent, row) => {
        const crmData = row.rowData
        return (
          <>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: { row: crmData, mode: "Operations" },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </>
        )
      },
      headerStyle: {
        minWidth: "125px",
      },
      hidden: false,
    },

    {
      dataField: "companyName",
      text: "Company Name",
      headerStyle: {
        minWidth: "140px",
      },
      hidden: false,
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "130px",
      },
      hidden: false,
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "130px",
      },
      hidden: false,
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "135px",
      },
      hidden: false,
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      headerStyle: {
        minWidth: "135px",
      },
      hidden: false,
    },
    
    {
      dataField: "deliverables",
      text: "No of Deliverables",
      headerStyle: {
        minWidth: "150px",
      },
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.deliverables}
            </span>
          </div>
        )
      },
      hidden: false,
    },

    {
      dataField: "crmAssign",
      text: "CRM Assign",
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row align-items-center">
            {row.crmAssign}
            <div className="ms-auto ml-2">
                <Button
                  style={{
                    background: "#17b77d",
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                    padding: "5px",
                    borderRadius: "3px",
                    marginLeft: "12px",
                  }}
                  onClick={() => {
                    setClientCompleteModal(true)
                    setClientLeadId(row._id)
                  }}
                >
                  <i className="fas fa-key"></i>
                </Button>
              </div>
            </div>
           )
      },
      headerStyle: {
        minWidth: "150px",
      },
      hidden: false,
    },
    {
      dataField: "assignedDate",
      text: "Assigned Date",
      headerStyle: {
        minWidth: "150px",
      },
      hidden: false,
    },
    {
      dataField: "completedByDate",
      text: "CompletedBy Date",
      headerStyle: {
        minWidth: "190px",
      },
      hidden: false,
    },
    {
      dataField: "completedByName",
      text: "CompletedBy Name",
      headerStyle: {
        minWidth: "190px",
      },
      hidden: false,
    },
    {
      dataField: "clearanceStatus",
      text: "Clearance Status",
      formatter: (cellContent, row) => {
        const paymentStatus = row.paymentStatus

        let badgeClassName = ""
        if (paymentStatus === "paid") {
          badgeClassName = "bg-success"
        } else if (paymentStatus === "unpaid") {
          badgeClassName = "bg-danger"
        } else if (paymentStatus === "partialpaid") {
          badgeClassName = ""
        } else {
          badgeClassName = "bg-danger"
        }
        const badgeStyle =
          paymentStatus === "partialpaid"
            ? { backgroundColor: "#f9851b", padding: "5px" }
            : paymentStatus === "complementary" ||
              paymentStatus === "Complementary" ?
              { backgroundColor: "#50a5f1", padding: "5px" } :
              paymentStatus === "expectation" ||
                paymentStatus === "Expectation" ? { backgroundColor: "#F1B44C", padding: "5px" } :
                { padding: "5px" }
        return (
          <div className="d-flex flex-row align-items-center">
            {!isEmpty(row.clearanceStatusName) ? (
              <span
                className={`badge ${badgeClassName}`}
                style={badgeStyle}
                onClick={() => {
                  if (
                    row.ecClearanceStatus === "PS24" &&
                    paymentStatus === "paid"
                  ) {
                    setClearanceModal(false)
                  } else {
                    setClearanceModal(true)
                    setClearanceDetails(row.clearanceDetails)
                  }
                }}
              >
                {row.clearanceStatusName}
              </span>
            ) : (
              "--"
            )}
            <div
              className="ms-auto ml-2"
              onClick={() => {
                setClearanceHistoryDetails(row.clearanceHistory)
                setClearanceHistoryModal(true)
              }}
            >
              <i
                className="fas fa-eye"
                style={{ color: "#50a5f1", fontSize: "13px" }}
              ></i>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "175px",
      },
      hidden: false,
    },
    {
      dataField: "reactive",
      text: "Reactive",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
      formatter: (cellContent, row) => {
      
        return (
        
              <Button
                style={{
                  border: "none",
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setReactiveModal(true)
                  setLeadId(row._id)
                  setReactiveData({
                    remarks:""
                  })
                }}
                className="btn btn-success"
               
              >
               Update
              </Button>)
           
      },
    },
  ]
  //update client complete
  const updateClientComplete = () => {
    const client_data={
      leadId:clientLeadId
    }
    setClientCompleteModal(false)
    dispatch(clientCompleteAction.updateClientComplete(client_data))
    setTimeout(() => {
      dispatch(clientCompleteAction.loadClientComplete(searchValue))
      toast.success("Client Complete Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
   
    }, 1000)
  }
  const updateReactive = () => {
    const reactive_details = {
      leadId: leadId,
      deliverableReactive:[{reactivateRemarks:reactiveData.remarks}]
    }
    console.log(reactive_details)
    dispatch(clientCompleteAction.addReactive(reactive_details))
    setTimeout(() => {
      dispatch(clientCompleteAction.loadClientComplete(searchValue))
      setReactiveModal(false)
      toast.success("Reactive Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  //Editable columns section
  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }
  //expand row product and team assign
  const [productAssignDetails, setProductAssignDetails] = useState([])
  const [productSubmitButton, setProductSubmitButton] = useState(false)

  const [multiProductModal, setMultiProductModal] = useState(false)
  const [multiTeamModal, setMultiTeamModal] = useState(false)

  const [teamAssignDetails, setTeamAssignDetails] = useState([])
  const [teamSubmitButton, setTeamSubmitButton] = useState(false)

  const [multiProductEmployee, setMultiProductEmployee] = useState([])
  const [multiTeamEmployee, setMultiTeamEmployee] = useState([])

  const [multiProductData, setMultiProductData] = useState({
    note: "",
  })
  const handleMultiProduct = (e) => {
    setMultiProductData({
      ...multiProductData,
      [e.target.name]: e.target.value,
    })
  }
  const [multiTeamData, setMultiTeamData] = useState({
    note: "",
  })
  const handleMultiTeam = (e) => {
    setMultiTeamData({ ...multiTeamData, [e.target.name]: e.target.value })
  }
  const [multiProductFile, setMultiProductFile] = useState([])
  const [productFileName, setProductFileName] = useState("")
  const [productFileLength, setProductFileLength] = useState("")

  const multiProductChange = async (e) => {
    if (e.target.files) {
      setMultiProductFile(e.target.files)
      var file = e.target.files
      setProductFileName(file[0].name)
      setProductFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiProductFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiProductFile(teamUploadValue)
          }
        })
      }
    }
  }
  const [multiTeamFile, setMultiTeamFile] = useState([])
  const [teamFileName, setTeamFileName] = useState("")
  const [teamFileLength, setTeamFileLength] = useState("")
  const multiTeamChange = async (e) => {
    if (e.target.files) {
      setMultiTeamFile(e.target.files)
      var file = e.target.files
      setTeamFileName(file[0].name)
      setTeamFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiTeamFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiTeamFile(teamUploadValue)
          }
        })
      }
    }
  }
  const handleClearAssignModal = () => {
    setMultiProductEmployee([])
    setMultiTeamEmployee([])
    setMultiProductData({ ...multiProductData, note: "" })
    setMultiTeamData({ ...multiTeamData, note: "" })
    setMultiProductFile([])
    setMultiTeamFile([])
    setProductFileLength("")
    setProductFileName("")
    setTeamFileLength("")
    setTeamFileName("")
  }
  //expand row
  const [expanded, setExpanded] = useState([])

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>

              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Product Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crm Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Product Lead Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                End Worker Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Quantity
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sheet/Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Deliverables
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Assigned History
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Overall Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Deliverable Status
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              row.deliverableDetails &&
              row.deliverableDetails.length > 0 ? (
              row.deliverableDetails.map((data) => {
                const sheet =
                  isEmpty(data.sheetLength) && data.sheetLength == null
                    ? 0
                    : data.sheetLength
                const eventDate = !isEmpty(data.eventDate)
                  ? moment(data.eventDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(dateFormat)
                  : "--"
                const eventDateValue =
                  eventDate === "Invalid date" ? "--" : eventDate

                const teamLeadName = !isEmpty(data.assignedTeamlead)
                  ? data.assignedTeamlead
                    .map((employee) => employee.empCode + "-" + employee.name)
                    .join(", ")
                  : ""
                const employeeName = !isEmpty(data.assignedEmployee)
                  ? data.assignedEmployee
                    .map((employee) => employee.empCode + "-" + employee.name)
                    .join(", ")
                  : ""
                const crmName = !isEmpty(data.assignedCrmEmployee)
                  ? data.assignedCrmEmployee
                    .map((employee) => employee.empCode + "-" + employee.name)
                    .join(", ")
                  : ""
                const colorCode =
                  !isEmpty(recordsMetaData) &&
                  recordsMetaData.processStatusOptions &&
                  recordsMetaData.processStatusOptions.length > 0 &&
                  recordsMetaData.processStatusOptions.find(
                    (_) => _.processStatusId === data.productionprocessstatus
                  ) &&
                  recordsMetaData.processStatusOptions.find(
                    (_) => _.processStatusId === data.productionprocessstatus
                  )?.colorCode


                return (
                  <tr key={data._id}>
                    <th scope="data">{data.eventName}</th>
                    <td>{eventDateValue}</td>

                    <td>{data.productName}</td>
                    <td>{crmName ? crmName : "--"}</td>
                    <td>
                      {" "}
                      <div className="d-flex flex-row align-items-center">
                        {teamLeadName ? teamLeadName : "--"}
                        <div className="ms-auto ml-2">
                          <Input
                            type="checkbox"
                            checked={productAssignDetails.some(
                              (item) => item._id === data._id
                            )}
                            style={{
                              width: "15px",
                              height: "15px",
                              marginLeft: "10px",
                            }}
                            onChange={(e) => {
                              e.stopPropagation()
                              if (
                                e.target.checked &&
                                !productAssignDetails.find(
                                  (item) => item._id === data._id
                                ) &&
                                isEmpty(teamAssignDetails)
                              ) {
                                setProductAssignDetails([
                                  ...productAssignDetails,
                                  data,
                                ])
                              } else {
                                setProductAssignDetails(
                                  productAssignDetails.filter(
                                    (item) => item._id !== data._id
                                  )
                                )
                              }
                              const anyChecked = productAssignDetails.some(
                                (item) => item._id !== data._id
                              )
                              setProductSubmitButton(anyChecked)
                              setLeadId(row._id)
                            }}
                          />
                        </div>
                      </div>{" "}
                    </td>
                    <td>
                      <div className="d-flex flex-row align-items-center">
                        {employeeName ? employeeName : "--"}
                        <div className="ms-auto ml-2">
                          <Input
                            type="checkbox"
                            checked={teamAssignDetails.some(
                              (item) => item._id === data._id
                            )}
                            style={{
                              width: "15px",
                              height: "15px",
                              marginLeft: "10px",
                            }}
                            onChange={(e) => {
                              e.stopPropagation()

                              if (
                                e.target.checked &&
                                !teamAssignDetails.find(
                                  (item) => item._id === data._id
                                ) &&
                                isEmpty(productAssignDetails)
                              ) {
                                setTeamAssignDetails([
                                  ...teamAssignDetails,
                                  data,
                                ])
                              } else {
                                setTeamAssignDetails(
                                  teamAssignDetails.filter(
                                    (item) => item._id !== data._id
                                  )
                                )
                              }
                              const anyChecked = teamAssignDetails.some(
                                (item) => item._id !== data._id
                              )
                              setLeadId(row._id)
                              setTeamSubmitButton(anyChecked)
                            }}
                          />
                        </div>
                      </div>
                    </td>
                    <td>{data.quantity}</td>
                    <td>{sheet + "/" + data.count}</td>
                    <td>
                      <div>
                        <Button
                          className="btn btn-info"
                          onClick={() => {
                            setDeliverablesData(data.operationalHistory)
                            setDeliverablesModal(true)
                          }}
                        >
                          Deliverables
                        </Button>
                      </div>
                    </td>
                    <td>
                      <div>
                        <a
                          onClick={() => {
                            assignHistory(data)
                          }}
                        >
                          <span
                            style={{
                              textDecoration: "underline",
                              color: "#E40D8C",
                            }}
                          >
                            History
                          </span>
                        </a>
                      </div>
                    </td>
                    <td style={{ color: "#e40d8c" }}>{data.overAllStatus}</td>
                    <td>
                      {data.productioProcessStatusName ? (
                        <button
                          style={{
                            background: colorCode,
                            border: "none",
                            cursor: "pointer",
                            color: "white",
                            padding: "2px",
                            borderRadius: "4px",
                          }}
                        >
                          {data.productioProcessStatusName}
                        </button>
                      ) : (
                        "--"
                      )}
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={8}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    expanded,
    onExpand: (row, isExpand) => {
      if (isExpand) {
        //setExpanded([...expanded, row._id])
        setExpanded([row._id])
      } else {
        // setExpanded(expanded.filter((id) => id !== row._id))
        setExpanded([])
      }
    },
    //onExpand:(isExpand,row) =>{ handleExpand(row.id, isExpand)},
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  useEffect(() => {
    if (productAssignDetails.length > 0) {
      setProductSubmitButton(true)
    } else {
      setProductSubmitButton(false)
    }
  }, [productAssignDetails])
  useEffect(() => {
    if (teamAssignDetails.length > 0) {
      setTeamSubmitButton(true)
    } else {
      setTeamSubmitButton(false)
    }
  }, [teamAssignDetails])
  //product submit
  const multipleProductEmployee =
    multiProductEmployee && multiProductEmployee.map((m) => m.value)

  const multiProductSubmit = () => {
    const product_details = {
      menuMode: 3,
      employeeId: multipleProductEmployee,
      notes: multiProductData.note,
      attachments: multiProductFile,
      leadAssignDetail: productAssignDetails.map((data) => {
        return {
          leadId: leadId,
          leadDelivarableId: data.leadDelivarableId,
          leadEventId: data.eventId,
        }
      }),
    }
    dispatch(clientCompleteAction.addProductAssign(product_details))
    setTimeout(() => {
      dispatch(clientCompleteAction.loadClientComplete(searchValue))
      setProductAssignDetails([])
      toast.success("Multiple Product Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiProductModal(false)
    }, 1000)
  }
  //multi team assign
  const teamMultipleEmployee =
    multiTeamEmployee && multiTeamEmployee.map((m) => m.value)

  const teamMultipleSubmit = () => {
    const team_details = {
      menuMode: 3,
      employeeId: teamMultipleEmployee,
      notes: multiTeamData.note,
      attachments: multiTeamFile,
      assignedBy: empId,
      leadAssignDetail: teamAssignDetails.map((data) => {
        return {
          leadId: leadId,
          leadDelivarableId: data.leadDelivarableId,
          leadEventId: data.eventId,
        }
      }),
    }

    dispatch(clientCompleteAction.addTeamAssign(team_details))
    setTimeout(() => {
      dispatch(clientCompleteAction.loadClientComplete(searchValue))
      setTeamAssignDetails([])
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiTeamModal(false)
    }, 1000)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      clientCompleteAction.loadClientComplete({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      //  empId: empId,
        isOperationStatus: true,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  let sNo = 0
  const exportToCsv = () => {
    var searchCompany = companies && companies ? companies.value : ""
    var searchBranch = branches && branches ? branches.value : ""
    var searchEvent = events && events ? events.value : ""
    var searchFromDate =
      eventClientCompleteData && eventClientCompleteData.fromDate
        ? moment(eventClientCompleteData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      eventClientCompleteData && eventClientCompleteData.toDate
        ? moment(eventClientCompleteData.toDate).format("YYYY-MM-DD")
        : ""
        var searchEmp = agent&&agent.value
        var searchLeadNo = eventClientCompleteData.leadNo
        ? eventClientCompleteData.leadNo
        : ""
    var searchvalue = {}
   
    searchvalue.isOperationStatus = true
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
   if(searchEmp){
    searchvalue.empId = searchEmp
   }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get_deliverable_client_completed_EE`, searchvalue)
      .then((response) => {
        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data) => {
            sNo = sNo + 1
            const eventCount =
              !isEmpty(data) && data.deliverableDetails.length > 0
                ? data.deliverableDetails.length
                : 0
            const deliverableCount =
              !isEmpty(data) && data.deliverableDetails.length > 0
                ? data.deliverableDetails.length
                : 0
            const overAllStatusList = !isEmpty(data.deliverableDetails)
              ? data.deliverableDetails.map((m) => m.overAllStatus).join(",")
              : "--"
            const overAllStatus = JSON.stringify(overAllStatusList).replace(
              /","/g,
              "\n"
            )
            const cpRemarks = !isEmpty(data.clientProfileRemarks)
              ? data.clientProfileRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            const dataDetails = !isEmpty(data.dataDetail)
              ? data.dataDetail[data.dataDetail.length - 1].isDataStatus
              : ""
            const dataValue =
              !isEmpty(dataDetails) && dataDetails == true
                ? "YES"
                : !isEmpty(dataDetails) && dataDetails == false
                  ? "NO"
                  : "--"
            return {
              _id: data.leadId,
              sNo: sNo,
              leadNo: data.leadNo,
              company: data.companyName ? data.companyName : "--",
              branch: data.branchName ? data.branchName : "--",
              clientName: data.clientName ? data.clientName : "--",
              clientCode: data.clientCode ? data.clientCode : "--",
              groomName: data.groomName ? data.groomName : "--",
              brideName: data.brideName ? data.brideName : "--",
              events: eventCount,
              leadDate: data.leadDate
                ? moment(data.leadDate).format(dateFormat)
                : "--",
              deliverables: deliverableCount,
              overallStatus: overAllStatus ? overAllStatus : "--",
              crmAssign: data.postCrmAssignedName
                ? data.postCrmAssignedName
                : "--",
              assignedDate:
                !isEmpty(data.postCrmAssignedDate) ||
                  data.postCrmAssignedDate != null
                  ? moment(data.postCrmAssignedDate).format(dateFormat)
                  : "--",
              clearanceStatus: data.ecClearanceStatusName
                ? data.ecClearanceStatusName
                : "--",
              cpStatus:
                data.clientProfileStatus && data.clientProfileStatus != null
                  ? data.clientProfileStatus
                  : "--",
              cpRemarks: cpRemarks,
              dataValue: dataValue,
              completedByName:data.clientCompletedByName?data.clientCompletedByName:"--",
          completedByDate:data.clientCompletedDate?moment(data.clientCompletedDate).format(dateFormat):"--"
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,  Company , Branch,Client Name,Client code,CP Remarks,CP Status,Groom Name,Bride Name,Lead Date,Deliverables,Overall Status,Crm Assign,Assigned Date,Completed By Name,Completed By Date,Clearance Status",
          ]

          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                company,
                branch,
                clientName,
                clientCode,
                cpRemarks,
                cpStatus,
                groomName,
                brideName,
                leadDate,
                deliverables,
                overallStatus,
                crmAssign,
                assignedDate,
                completedByName,
                completedByDate,
                clearanceStatus,
              } = user
              acc.push([
                sNo,
                leadNo,
                company,
                branch,
                clientName,
                clientCode,
                cpRemarks,
                cpStatus,
                groomName,
                brideName,
                leadDate,
                deliverables,
                overallStatus,
                crmAssign,
                assignedDate,
                completedByName,
                completedByDate,
                clearanceStatus,
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ClientComplete.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
    // }
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {productSubmitButton ? (
                            <Button
                              className="btn btn-success text-nowrap"
                              onClick={() => {
                                setMultiProductModal(true)
                                handleClearAssignModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              Product Lead Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          {teamSubmitButton ? (
                            <Button
                              className="btn btn-danger text-nowrap"
                              onClick={() => {
                                setMultiTeamModal(true)
                                handleClearAssignModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              End Worker Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          expandRow={expandRow}
                          noDataIndication={"No Data Found..."}
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: clientComplete_details.length,
    data:
      !isEmpty(clientComplete_details) && clientComplete_details.length > 0
        ? clientComplete_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(clientComplete_details) && clientComplete_details.length > 0
        ? clientComplete_details
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(events) ||
      !isEmpty(eventClientCompleteData.fromDate) ||
      !isEmpty(eventClientCompleteData.toDate) ||
      !isEmpty(agent)
    ) {
      var searchCompany = companies && companies ? companies.value : ""
      var searchBranch = branches && branches ? branches.value : ""
      var searchEvent = events && events ? events.value : ""
      var searchAgent = agent && agent ? agent.value : ""
      var searchLeadNo = eventClientCompleteData.leadNo
      ? eventClientCompleteData.leadNo
      : ""
      var searchFromDate =
        eventClientCompleteData && eventClientCompleteData.fromDate
          ? moment(eventClientCompleteData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        eventClientCompleteData && eventClientCompleteData.toDate
          ? moment(eventClientCompleteData.toDate).format("YYYY-MM-DD")
          : ""

      var searchvalue = {}
    
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      searchvalue.isOperationStatus = true
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchAgent) {
        searchvalue.empId = searchAgent
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEvent) {
        searchvalue.eventNameId = searchEvent
      }
      if (searchFromDate) {
        searchvalue.eventFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventToDate = searchToDate
      }
     
      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(clientCompleteAction.loadClientComplete(searchvalue))
    } else {
      dispatch(
        clientCompleteAction.loadClientComplete({
          page: page,
          limit: sizePerPage,
         // empId: empId,
          isOperationStatus: true,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  useEffect(() => {
    if (crmError) {
      toast.error(crmError, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        onClose: () => {
          dispatch(clientCompleteAction.crmReset())
        },
      })
    } else if (crmSuccess) {
      toast.success(crmSuccess, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        onClose: () => {
          dispatch(clientCompleteAction.crmReset())
        },
      })
    }
  }, [crmError, crmSuccess])
  //DATE
  const date = moment().format("YYYY-MM-DD")
  //ADD CLEARANCE
  const addClearance = () => {
    const level =
      clearanceDetails.ecClearanceStatus === "PS22" &&
        clearanceDetails.ecClearanceStatusName === "LEVEL 1 APPROVED"
        ? "LEVEL2"
        : "LEVEL1"

    const applyClearance = {
      leadId: clearanceDetails.leadId,
      mode: level,
      type: "unpaid",
      clearanceDate: date,
      clearanceBy: empId,
      clearanceStatus: "PS21",
      remarks: "",
    }
    console.log(applyClearance, "applyClearance")
    specificDispatch(clientCompleteAction.addClearance(applyClearance))
    setTimeout(() => {
      dispatch(clientCompleteAction.loadClientComplete(searchValue))
      setClearanceModal(false)
    }, 1000)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Operation"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Lead No"}>
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          name="leadNo"
                          value={eventClientCompleteData.leadNo}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Lead No"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"CRM Name"}
                          >
                            {"CRM Name"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="agent"
                          key={agentKey}
                          items={recordsMetaData.employeeOptions}
                          value={agent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setAgent(e)}
                          onChange={(e) => setAgent(e.target.value)}
                          onClear ={()=>setAgent([])}
                          placeholder="Enter CRM Name"
                          fuseOptions={fuseAgentOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={eventClientCompleteData.fromDate}
                          max={eventClientCompleteData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={eventClientCompleteData.toDate}
                          min={eventClientCompleteData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={clientCompleteDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={clientComplete_details.totalDataCount}
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {historyModal && (
                    <Modal size="xl" show={historyModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Assigned History
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Type</th>
                                <th>Employee Name</th>
                                <th>Notes</th>
                                <th>Attachment</th>
                                <th>Created On</th>
                                <th>Created By</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(history_details) &&
                                history_details.data.length > 0 ? (
                                history_details.data.map((data, index) => {
                                  const employeeName =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId)
                                      ? data.PrecrmId.name
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? data.assignedTeamlead[0].employeeId
                                          .map((employee) => employee.name)
                                          .join()
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? data.assignEmployee[0].employeeId
                                            .map((employee) => employee.name)
                                            .join()
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? data.assignCrmEmployee[0].employeeId
                                              .map((employee) => employee.name)
                                              .join()
                                            : "--"

                                  const typeName = data.PrecrmId
                                    ? "CRM"
                                    : data.assignedTeamlead
                                      ? "PL"
                                      : data.assignCrmEmployee
                                        ? "CRM"
                                        : data.assignEmployee
                                          ? "EW"
                                          : "--"

                                  const notesName =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId) &&
                                      data.PrecrmId.notes
                                      ? data.PrecrmId.notes
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead) &&
                                        data.assignedTeamlead[0].notes !== ""
                                        ? data.assignedTeamlead[0].notes
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee) &&
                                          data.assignEmployee[0].notes !== ""
                                          ? data.assignEmployee[0].notes
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee) &&
                                            data.assignCrmEmployee[0].notes !== ""
                                            ? data.assignCrmEmployee[0].notes
                                            : "--"
                                  const createdOn =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId) &&
                                      data.PrecrmId.createdOn
                                      ? moment
                                        .utc(data.PrecrmId.createdOn)
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? moment
                                          .utc(
                                            data.assignedTeamlead[0].createdOn
                                          )
                                          .format(`${dateFormat} ${"hh:mm A"}`)
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? moment
                                            .utc(data.assignEmployee[0].createdOn)
                                            .format(`${dateFormat} ${"hh:mm A"}`)
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? moment
                                              .utc(
                                                data.assignCrmEmployee[0].createdOn
                                              )
                                              .format(`${dateFormat} ${"hh:mm A"}`)
                                            : "--"
                                  const createdBy =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId)
                                      ? data.PrecrmId.createdByName
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? data.assignedTeamlead[0].createdByName
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? data.assignEmployee[0].createdByName
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? data.assignCrmEmployee[0].createdByName
                                            : "--"
                                  const attachment =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId)
                                      ? data.PrecrmId.attachments
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? data.assignedTeamlead[0].attachments
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? data.assignEmployee[0].attachments
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? data.assignCrmEmployee[0].attachments
                                            : "--"
                                  const attachmentValue = !isEmpty(attachment)
                                    ? attachment[0]
                                    : []
                                  const splitAttach = !isEmpty(attachmentValue)
                                    ? attachmentValue.split(".")
                                    : ""
                                  const attachExtension = !isEmpty(splitAttach)
                                    ? splitAttach.pop()
                                    : ""
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{typeName}</td>
                                      <td>{employeeName}</td>
                                      <td>{notesName}</td>
                                      <td>
                                        {" "}
                                        {(attachmentValue &&
                                          attachExtension === "jpeg") ||
                                          (attachmentValue &&
                                            attachExtension === "jpg") ||
                                          (attachmentValue &&
                                            attachExtension === "png") ? (
                                          <a
                                            onClick={() =>
                                              window.open(
                                                attachmentValue,
                                                "_blank"
                                              )
                                            }
                                          >
                                            <span
                                              style={{
                                                textDecoration: "underline",
                                                color: "#E40D8C",
                                              }}
                                            >
                                              View
                                            </span>
                                          </a>
                                        ) : (attachmentValue &&
                                          attachExtension === "mp3") ||
                                          (attachmentValue &&
                                            attachExtension === "m4a") ||
                                          (attachmentValue &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachmentValue}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>

                                      <td>{createdOn}</td>
                                      <td>{createdBy}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr key={0}>
                                  <td className="text-align-center" colSpan={7}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setHistoryModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}

                  {multiProductModal && (
                    <Modal size="xl" show={multiProductModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Product Lead
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              isMulti
                              type="text"
                              name="multiProductEmployee"
                              value={multiProductEmployee}
                              onChange={(e) => setMultiProductEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiProductData.note}
                              onChange={(e) => handleMultiProduct(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="multiProductFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => multiProductChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {productFileLength ? productFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {productFileName ? productFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiProductModal(false)
                            setProductAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            multiProductSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiTeamModal && (
                    <Modal size="xl" show={multiTeamModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Team
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              isMulti
                              type="text"
                              name="multiTeamEmployee"
                              value={multiTeamEmployee}
                              onChange={(e) => setMultiTeamEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiTeamData.note}
                              onChange={(e) => handleMultiTeam(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="multiTeamFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => multiTeamChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {teamFileLength ? teamFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {teamFileName ? teamFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiTeamModal(false)
                            setTeamAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            teamMultipleSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {deliverablesModal && (
                    <Modal size="xl" show={deliverablesModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Deliverables
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Mode</th>
                                <th>Tat Date</th>
                                <th>Link</th>
                                <th>Remarks</th>
                                <th>Attachment</th>
                                <th>Quantity</th>
                                <th>Created By</th>
                                <th>Created On</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(deliverablesData) &&
                                deliverablesData.length > 0 ? (
                                deliverablesData.map((data, index) => {
                                  const createdOn = !isEmpty(data.createdOn)
                                    ? moment
                                      .utc(data.createdOn)
                                      .format(`${dateFormat} ${"hh:mm A"}`)
                                    : "--"

                                  const attachment = !isEmpty(data.attachment)
                                    ? data.attachment.map((m) => m).join()
                                    : ""
                                  const attachExtension = !isEmpty(attachment)
                                    ? attachment.split(".").pop()
                                    : ""
                                  const tatDate = data.tat
                                    ? moment(data.tat).format(dateFormat)
                                    : "--"
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.mode ? data.mode : "--"}</td>
                                      <td>{tatDate}</td>
                                      <td>{data.link ? data.link : "--"}</td>
                                      <td>
                                        {data.remarks ? data.remarks : "--"}
                                      </td>
                                      <td>
                                        {" "}
                                        {(attachment &&
                                          attachExtension === "jpeg") ||
                                          (attachment &&
                                            attachExtension === "jpg") ||
                                          (attachment &&
                                            attachExtension === "png") ? (
                                          <div className="d-flex flex-row align-items-center">
                                            <a
                                              onClick={() =>
                                                window.open(
                                                  attachment,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#E40D8C",
                                                }}
                                              >
                                                View
                                              </span>
                                            </a>
                                            <div className="ms-auto ml-2">
                                              <span
                                                style={{
                                                  color: "#17b77d",
                                                }}
                                              >
                                                <i className="fa fa-download fa-lg"></i>
                                              </span>
                                            </div>
                                          </div>
                                        ) : (attachment &&
                                          attachExtension === "mp3") ||
                                          (attachment &&
                                            attachExtension === "m4a") ||
                                          (attachment &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachment}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                      <td>
                                        {data.quantity ? data.quantity : "--"}
                                      </td>
                                      <td>
                                        {data.createdByName
                                          ? data.createdByName
                                          : "--"}
                                      </td>
                                      <td>{createdOn}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td className="text-align-center" colSpan={8}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setDeliverablesModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {clearanceModal && (
                    <Modal show={clearanceModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Clearance Report</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        Do You Want To Clearance The Report?
                      </Modal.Body>

                      <Modal.Footer>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              setClearanceModal(false)
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              setClearanceModal(false)
                              addClearance()
                            }}
                            style={{ marginLeft: "20px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                            Confirm
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {clearanceHistoryModal && (
                    <Modal
                      show={clearanceHistoryModal}
                      size="lg"
                      backdrop="static"
                    >
                      <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
                        <h5 style={{ color: "white" }}>
                          Clearance Status History
                        </h5>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered striped responsive>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Clearance Date</th>
                                  <th>Payment Status</th>
                                  <th>Level</th>
                                  <th>Payment %</th>
                                  <th>Remarks</th>
                                  <th>Attachment</th>
                                  <th>Status</th>
                                  <th>Created By</th>
                                  <th>Created On</th>
                                </tr>
                              </thead>
                              <tbody>
                                {clearanceHistoryDetails &&
                                  clearanceHistoryDetails.length > 0 ? (
                                  clearanceHistoryDetails.map((data, index) => {
                                    const attachmentValue = !isEmpty(
                                      data.attachment
                                    )
                                      ? data.attachment
                                      : []
                                    const splitAttach = !isEmpty(
                                      attachmentValue
                                    )
                                      ? attachmentValue.split(".")
                                      : ""
                                    const attachExtension = !isEmpty(
                                      splitAttach
                                    )
                                      ? splitAttach.pop()
                                      : ""
                                    const clearanceDate = !isEmpty(
                                      data.clearanceDate
                                    )
                                      ? moment(data.clearanceDate)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                      : "--"
                                    const createdAt = !isEmpty(data.CreatedOn)
                                      ? moment(data.CreatedOn)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                      : "--"
                                    const processStatusName =
                                      !isEmpty(recordsMetaData) &&
                                        !isEmpty(
                                          recordsMetaData.processStatusOptions
                                        ) &&
                                        recordsMetaData.processStatusOptions &&
                                        recordsMetaData.processStatusOptions
                                          .length > 0
                                        ? recordsMetaData.processStatusOptions.find(
                                          (_) =>
                                            _.processStatusId ==
                                            data.clearanceStatus
                                        )
                                        : "--"
                                    const btnColor =
                                      data.paymentType === "paid"
                                        ? "btn-success"
                                        : data.paymentType === "complementary" ||
                                          data.paymentType === "Complementary" ?
                                          "btn-info"
                                          : data.paymentType === "expectation" ||
                                            data.paymentType === "Expectation" ?
                                            "btn-warning"
                                            : data.paymentType === "unpaid"
                                              ? "btn-danger"
                                              : data.paymentType === "partialpaid"
                                                ? ""
                                                : "btn-danger"

                                    const btnStyle =
                                      data.paymentType === "partialpaid"
                                        ? {
                                          backgroundColor: "#f9851b",
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "4px 6px",
                                          borderRadius: "4px",
                                        }
                                        : {
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "4px 6px",
                                          borderRadius: "4px",
                                        }
                                    return (
                                      <>
                                        <tr key={data._id}>
                                          <td>{index + 1}</td>
                                          <td>{clearanceDate}</td>
                                          <td>
                                            {data.paymentType
                                              ? data.paymentType
                                              : "--"}
                                          </td>
                                          <td>
                                            {data.mode ? data.mode : "--"}
                                          </td>
                                          <td>
                                            {data.paymentReceivedPercentage
                                              ? data.paymentReceivedPercentage
                                              : "--"}
                                          </td>

                                          <td>
                                            {data.remarks ? data.remarks : "--"}
                                          </td>
                                          <td>
                                            {" "}
                                            {(attachmentValue &&
                                              attachExtension === "jpeg") ||
                                              (attachmentValue &&
                                                attachExtension === "jpg") ||
                                              (attachmentValue &&
                                                attachExtension === "png") ? (
                                              <a
                                                onClick={() =>
                                                  window.open(
                                                    attachmentValue,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <span
                                                  style={{
                                                    textDecoration: "underline",
                                                    color: "#E40D8C",
                                                  }}
                                                >
                                                  View
                                                </span>
                                              </a>
                                            ) : (attachmentValue &&
                                              attachExtension === "mp3") ||
                                              (attachmentValue &&
                                                attachExtension === "m4a") ||
                                              (attachmentValue &&
                                                attachExtension === "mp4") ? (
                                              <a href={attachmentValue}>
                                                <audio controls>
                                                  <source
                                                    src={attachmentValue}
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser does not support
                                                  the audio element.
                                                </audio>
                                              </a>
                                            ) : (
                                              "--"
                                            )}
                                          </td>
                                          <td>
                                            <button
                                              className={`btn ${btnColor}`}
                                              style={btnStyle}
                                            >
                                              {processStatusName.label}
                                            </button>
                                          </td>
                                          <td>
                                            {data.insertedByName
                                              ? data.insertedByName
                                              : "--"}
                                          </td>
                                          <td>{createdAt}</td>
                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={10}
                                      className="text-align-center"
                                    >
                                      {"No Data Found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setClearanceHistoryModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                      {clientCompleteModal && (
                    <Modal show={clientCompleteModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Confirm</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        Are you sure , You want to Event Client Complete?
                      </Modal.Body>
                      <Modal.Footer>
                        <div>
                          <Button
                            // type="submit"
                            onClick={() => {
                              setClientCompleteModal(false)
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              //clientCompleteModal(false)
                             updateClientComplete()
                            }}
                            style={{ marginLeft: "10px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                             Update
                          </Button>
                         
                        
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                         {reactiveModal && (
        <Modal size="md" show={reactiveModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Reactive
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
            
              <Col md="12" lg="12" xl="12" sm="12" className="mt-1">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"remarks"}>
                    {"Remarks"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="remarks"
                  value={reactiveData.remarks}
                  onChange={(e) => handleReactiveChange(e)}
                  placeholder="Enter Remarks"
                />
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setReactiveModal(false)}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="secondary"
              className={"btn btn-success"}
              data-bs-dismiss="modal"
              onClick={(e) => updateReactive(e)}
            >
              update
            </Button>
          </Modal.Footer>
        </Modal>
      )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

EventClientComplete.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EventClientComplete)
)
